module.exports = __webpack_public_path__ + "img/style_model_preview_682.392263c8.jpg";